import classNames from "classnames"
import { navigate } from "gatsby"
import React, { useRef, useState } from "react"
import Icon from "../../images/icons/icons.js"
import VideoModal from "../modal/videoDialog.js"

const getClassNames = (buttonStyle, size, classes) => {
	return classNames(
		"btn",
		{
			"btn-primary": buttonStyle === "fill",
			"btn-outline": buttonStyle === "outline",
			"btn-negative": buttonStyle === "negative",
			"btn-sm": size === "sm",
			"btn-base": size === "base",
			"btn-lg": size === "lg",
			"btn-xl": size === "xl",
			"btn-2xl": size === "2xl",
		},
		classes
	)
}

const BaseButton = ({
	id,
	buttonStyle,
	size,
	type,
	iconName,
	iconPosition,
	onClick,
	disabled,
	children,
	className,
	video,
	onClickLink,
	...props
}) => {
	const [isModelOpen, setIsModelOpen] = useState(false)

	const buttonRef = useRef()
	const buttonClasses = getClassNames(buttonStyle, size, className)

	const openVideoModal = () => {
		setIsModelOpen(true)
	}

	return (
		<>
			<button
				id={id}
				ref={buttonRef}
				className={buttonClasses}
				onClick={
					onClickLink
						? (e) => {
								e.preventDefault()
								navigate(onClickLink)
						  }
						: video
						? (e) => {
								e.preventDefault()
								openVideoModal()
						  }
						: onClick
				}
				disabled={disabled}
				{...props}
			>
				{iconPosition === "left" && (
					<Icon
						iconName={iconName}
						className="icon-left"
					/>
				)}
				{children}
				{iconPosition === "right" && (
					<Icon
						iconName={iconName}
						className="icon-right"
					/>
				)}
			</button>

			<React.Fragment>
				{isModelOpen && (
					<VideoModal
						isOpen={isModelOpen}
						setIsOpen={setIsModelOpen}
						video={video}
					/>
				)}
			</React.Fragment>
		</>
	)
}

function PlayButton({ className, video, ...props }) {
	const [isOpen, setIsOpen] = useState(false)

	const openVideoModal = () => {
		setIsOpen(true)
	}

	return (
		<>
			<button
				className={`playbtn ${className} focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500`}
				onClick={() => {
					openVideoModal()
				}}
				{...props}
			>
				<div className="oval">
					<div className="triangle-outer">
						<div className="triangle"></div>
					</div>
				</div>
			</button>

			<React.Fragment>
				{isOpen && (
					<VideoModal
						isOpen={isOpen}
						setIsOpen={setIsOpen}
						video={video}
					/>
				)}
			</React.Fragment>
		</>
	)
}

const Button = {
	BaseButton: BaseButton,
}

export { Button, PlayButton }
